import { Maybe } from 'graphql/jsutils/Maybe';
import { Pipe, PipeTransform } from '@angular/core';

import { ProductCategory } from '@iss/wo-common/trade-off';

type OrderLineData = Readonly<{
  productData: Readonly<{
    productCategory: ProductCategory;
    packageTypeId?: Maybe<string>;
  }>;
}>;

type OrderLine<T extends OrderLineData> = T;

type ServiceOrderLinePipeInput<T extends OrderLineData> = readonly OrderLine<T>[];

@Pipe({
  name: 'extraServiceOrderLines',
  standalone: true,
})
export class ExtraServiceOrderLinesPipe implements PipeTransform {
  public transform<T extends OrderLineData>(input: ServiceOrderLinePipeInput<T>): readonly OrderLine<T>[] {
    return input
      .filter(({ productData }) => !productData.packageTypeId)
      .sort((a, b) => a.productData.productCategory.localeCompare(b.productData.productCategory));
  }
}
